<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list row-key="PurchaseId" ref="list" unit="用户" :expand-all-row="true" :page="!isPage && page" :show-checkbox="!is_listDialog && isShow"
      :show-query="true" :query-params="params" :get-data-func="api.list" urlHash="business/purchase/entrystore/emptor" @row-select="toggleRow"
      :showTrendTable="isShow" :temp-params="tempParams">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    
    <!-- 明细 -->
    <el-button v-if="show" type="primary" @click="onCustomTable" icon="el-icon-s-tools" style="margin:30px 0 10px 0">
      明细项
    </el-button>
    <el-table 
      ref="multipleTable" :row-key="row => row.Prop" 
      :data="subList"  v-if="show"
      stripe border @selection-change="handleSelectionChange"> 
      <el-table-column type="selection" v-if="is_listDialog" width="55"> </el-table-column>
      <template v-for="(item,index) in tableColumns" >
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column 
            :resizable="false"
            :key="`${item.Prop}-${index}`" :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label" 
            :align="item.Align ?? 'left'" 
            :min-width="item.Width"
            show-overflow-tooltip
          >
          <template slot-scope="{row}">
            <span v-if="isNumericProperty(item.Prop)">
              {{ $commonJs.toThousands(row[item.Prop]) }}
            </span>
            <span v-else>
              {{ row[item.Prop] }}
            </span>
          </template>
        </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog ref="customTableDialog" @onSave="onSave" :initTableData='tableColumns' tableType='采购订单明细'/>
    
    <!-- <el-table ref="multipleTable" class="subItem-table" tooltip-effect="dark" :data="subList" v-if="show"
      @selection-change="handleSelectionChange" border>
      <el-table-column type="selection" v-if="is_listDialog" width="55"> </el-table-column>
      <el-table-column align="left" prop="ProductNo" label="存货编码"></el-table-column>
      <el-table-column align="left" prop="ProductName" label="存货名称" min-width="120px" show-overflow-tooltip></el-table-column>
      <el-table-column align="left" prop="ProductSpec" label="规格"></el-table-column>
      <el-table-column align="left" prop="ColorName" label="颜色"></el-table-column>
      <el-table-column align="left" prop="UnitName" label="计量单位"></el-table-column>
      <el-table-column align="right" prop="PurchaseQuantity" label="数量">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.PurchaseQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="Price" label="单价" v-if="canPrice"></el-table-column>
      <el-table-column align="right" prop="Amount" label="金额" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

export default {
  mixins: [listMixin],
  components: { list,customTableDialog },
  props: {
    params: {
      typeof: Object,
      default: () => {}
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    is_listDialog: {
      typeof: Boolean,
      default: false,
    },
    isFunc: {
      type: Boolean,
      default: true
    },
    isPage: {
      type: Boolean,
      default: false
    },
    isSelect: {
      typeof: Boolean,
      default: false,
    },
    // canPrice: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  data() {
    return {
      api: require("@/api/pu/puOrder").default,
      FieldSettingApi: require("@/api/sy/fieldSetting").default,
      show: false,
      orderNo: "",
      subSelectList: [],
      subList: [],
      TradeUnitId: null,
      TradeUnitName: "",
      InvoiceTypeId: null,
      InvoiceTypeName: null,
      PayId: null,
      PayName: null,
      params: {
        TradeUnitId:null
      },
      tempParams: {
        SourceDocId: '',
        SourceType: '',
        TradeUnitId:null
      },
      tableColumns:[]
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/purchase/emptor");
    },
  },
  mounted() {
    if (!this.$permission.canPrice("/business/purchase/emptor")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(item => item.tableName == "RemainAmount");
      list.tableList.splice(findIndex, 1);
      const findIndex1 = list.tableList.findIndex(item => item.tableName == "TaxAmount");
      list.tableList.splice(findIndex1, 1);
    }
      
    this.params.TradeUnitId = this.tempParams.TradeUnitId
  },
  activated() {
    this.getRouterInfo()
  },
  mounted(){
    this.getTableColumns()
  },
  
  watch: {
    params(val) {
      console.log('val11111', val)
      this.params.TradeUnitId = val.TradeUnitId
    }
  },
  methods: {
     /** 价格权限的字段 */
     shouldShowColumn(item) {
      if (!item.IsShow) return false;
      const priceProps = [
        'PurchasePrice', 'SalePrice', 'RetailPrice', 'QuotedPrice', 
        'Discount', 'TaxRate', 'Price', 'TaxPrice', 'Amount', 
        'TaxLimit', 'TaxAmount', 'DiscountAmount'
      ];
      return (this.canPrice && priceProps.includes(item.Prop)) || !priceProps.includes(item.Prop);
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ['PurchaseQuantity', 'Amount',].includes(prop);
    },
    async getTableColumns(){
      const res = await this.FieldSettingApi.list({Type: "采购订单明细"})
      this.tableColumns = [] 
      this.tableColumns = res.Data
    },
    onCustomTable(){
      this.$refs.customTableDialog.dialogVisible = true
    },
    onSave(){
      this.getTableColumns()
      this.$message.success('保存成功')
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    getRouterInfo() {
      if (this.$router.history.current.params) {
        this.tempParams.SourceDocId = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceDocId
        }
        this.tempParams.SourceType = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceType
        }
        this.tempParams.Ids = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.Ids
        }
        this.tempParams.SaOrderNo = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SaOrderNo
        }
        if (this.$router.history.current.params.type === '明细') {
          this.tempParams.SaOrderNo = {
            paramValueType: 'resetParamValue',
            isReset: true,
            value: this.$router.history.current.params.DocNo
          }
        }
        this.$refs.list.getData()
      }
    },
    // 选择报价明细
    handleSelectionChange(data) {
      this.subSelectList = data;
    },
    toggleSelection(rows) {
      let $multipleTable = this.$refs.multipleTable;
      if ($multipleTable) {
        if (rows) {
          rows.forEach(row => {
            $multipleTable.toggleRowSelection(row);
          });
        } else {
          $multipleTable.clearSelection();
        }
      }
    },
    clearSubSelectList() {
      this.toggleSelection()
    },
    clearList() {
      this.subSelectList = [];
      this.show = false;
    },
    toggleRow(data) {
      console.log("当前行");
      console.log("object", data);
      // if (!this.is_listDialog) return;
      this.show = false;
      this.api.info(data.OrderId).then((res) => {
        if (res.Code === 0 && res.Data.length != 0) {
          this.show = true;
          this.TradeUnitId = res.Data.TradeUnitId;
          this.TradeUnitName = res.Data.TradeUnitName;
          this.orderNo = res.Data.DocNo

          this.InvoiceTypeId = res.Data.InvoiceTypeId;
          this.InvoiceTypeName = res.Data.InvoiceTypeName;
          this.PayId = res.Data.PayId;
          this.PayName = res.Data.PayName;

          if (this.isSelect) {
            res.Data.Products.forEach(item => {
              item.PurchaseQuantity = item.PurchaseQuantity - (item.PuDocOccupyQuantity ?? 0) - (item.StInDocOccupyQuantity ?? 0)
              item.Amount = Number((item.PurchaseQuantity * item.Price).toFixed(2));
            })

            let tList = res.Data.Products.filter(item => {
              return item.PurchaseQuantity > 0
            })


            console.log('tList', tList)
            this.subList = tList;
          } else {
            this.subList = res.Data.Products;
          }
        }
      });
      // this.subList.push(data)
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
